<div class="section-card">
  <div
    class="section-header mb-3 d-flex align-items-center justify-content-between"
  >
    <h4 class="section-title">Customer Details</h4>
    <!-- <button class="btn-icon-primary bg-white" aria-label="Copy details">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.375 18.7497C8.80208 18.7497 8.31163 18.5457 7.90365 18.1377C7.49566 17.7297 7.29167 17.2393 7.29167 16.6663V4.16634C7.29167 3.59342 7.49566 3.10297 7.90365 2.69499C8.31163 2.287 8.80208 2.08301 9.375 2.08301H18.75C19.3229 2.08301 19.8134 2.287 20.2214 2.69499C20.6293 3.10297 20.8333 3.59342 20.8333 4.16634V16.6663C20.8333 17.2393 20.6293 17.7297 20.2214 18.1377C19.8134 18.5457 19.3229 18.7497 18.75 18.7497H9.375ZM5.20833 22.9163C4.63542 22.9163 4.14497 22.7123 3.73698 22.3044C3.32899 21.8964 3.125 21.4059 3.125 20.833V6.24967H5.20833V20.833H16.6667V22.9163H5.20833Z"
          fill="#004B64"
        />
      </svg>
    </button> -->
  </div>
  <div class="info-grid">
    <div class="info-item">
      <p class="info-label">Customer name</p>
      <p class="info-value">{{ orderBy?.name }}</p>
    </div>
    <div class="info-item">
      <p class="info-label">Mobile Number</p>
      <p class="info-value">{{ orderBy?.mobileNo }}</p>
    </div>
  </div>
  <div class="info-item">
    <p class="info-label">Email</p>
    <p class="info-value">{{ orderBy?.email }}</p>
  </div>
  <div class="verified-card">
    <div class="verified-content">
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.6875 15.8747L11.875 14.0935C11.6458 13.8643 11.3594 13.7497 11.0156 13.7497C10.6719 13.7497 10.375 13.8747 10.125 14.1247C9.89583 14.3539 9.78125 14.6456 9.78125 14.9997C9.78125 15.3539 9.89583 15.6456 10.125 15.8747L12.8125 18.5622C13.0625 18.8122 13.3542 18.9372 13.6875 18.9372C14.0208 18.9372 14.3125 18.8122 14.5625 18.5622L19.875 13.2497C20.125 12.9997 20.2448 12.7081 20.2344 12.3747C20.224 12.0414 20.1042 11.7497 19.875 11.4997C19.625 11.2497 19.3281 11.1195 18.9844 11.1091C18.6406 11.0987 18.3438 11.2185 18.0938 11.4685L13.6875 15.8747ZM10.1875 27.1872L8.375 24.1247L4.9375 23.3747C4.625 23.3122 4.375 23.1508 4.1875 22.8903C4 22.6299 3.92708 22.3435 3.96875 22.031L4.3125 18.4997L1.96875 15.8122C1.76042 15.5831 1.65625 15.3122 1.65625 14.9997C1.65625 14.6872 1.76042 14.4164 1.96875 14.1872L4.3125 11.4997L3.96875 7.96847C3.92708 7.65597 4 7.36951 4.1875 7.1091C4.375 6.84868 4.625 6.68722 4.9375 6.62472L8.375 5.87472L10.1875 2.81222C10.3542 2.54139 10.5833 2.3591 10.875 2.26535C11.1667 2.1716 11.4583 2.18722 11.75 2.31222L15 3.68722L18.25 2.31222C18.5417 2.18722 18.8333 2.1716 19.125 2.26535C19.4167 2.3591 19.6458 2.54139 19.8125 2.81222L21.625 5.87472L25.0625 6.62472C25.375 6.68722 25.625 6.84868 25.8125 7.1091C26 7.36951 26.0729 7.65597 26.0312 7.96847L25.6875 11.4997L28.0312 14.1872C28.2396 14.4164 28.3438 14.6872 28.3438 14.9997C28.3438 15.3122 28.2396 15.5831 28.0312 15.8122L25.6875 18.4997L26.0312 22.031C26.0729 22.3435 26 22.6299 25.8125 22.8903C25.625 23.1508 25.375 23.3122 25.0625 23.3747L21.625 24.1247L19.8125 27.1872C19.6458 27.4581 19.4167 27.6403 19.125 27.7341C18.8333 27.8278 18.5417 27.8122 18.25 27.6872L15 26.3122L11.75 27.6872C11.4583 27.8122 11.1667 27.8278 10.875 27.7341C10.5833 27.6403 10.3542 27.4581 10.1875 27.1872Z"
          fill="#17B26A"
        />
      </svg>

      <div class="verified-details">
        <p class="verified-text">{{ orderBy?.companyName }}</p>
        <!-- <p class="gstin-text">GSTIN : 07AAGFF2194N1Z1</p> -->
      </div>
      <!-- <button class="btn-copy-gstin" aria-label="Copy GSTIN">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 15.0003C7.04167 15.0003 6.64931 14.8371 6.32292 14.5107C5.99653 14.1844 5.83333 13.792 5.83333 13.3337V3.33366C5.83333 2.87533 5.99653 2.48296 6.32292 2.15658C6.64931 1.83019 7.04167 1.66699 7.5 1.66699H15C15.4583 1.66699 15.8507 1.83019 16.1771 2.15658C16.5035 2.48296 16.6667 2.87533 16.6667 3.33366V13.3337C16.6667 13.792 16.5035 14.1844 16.1771 14.5107C15.8507 14.8371 15.4583 15.0003 15 15.0003H7.5ZM4.16667 18.3337C3.70833 18.3337 3.31597 18.1705 2.98958 17.8441C2.66319 17.5177 2.5 17.1253 2.5 16.667V5.00033H4.16667V16.667H13.3333V18.3337H4.16667Z"
            fill="#17B26A"
          />
        </svg>
      </button> -->
    </div>
  </div>
</div>
<hr class="divider" />
